import React, { useState } from "react";
import AddNewDoctor from "../addNewDoctor";
import { TableColumnsItem } from "../../../../interfaces/components/mainTable";
import { ButtonType, ColumnType, ModalType } from "../../../../shared/utils/enums";
import { sampleDoctorData } from "../../../../shared/static/data/doctors";
import MainTable from "../../../../components/mainTable";
import { useDispatch } from "react-redux";
import { showModal, hideModal } from "../../../../connected-components/modal/reducer";

const DoctorsList = () => {
  const dispatch = useDispatch();
  const [doctors, setDoctors] = useState(sampleDoctorData);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleRowPress = (doctor: any) => {
    console.log("Doctor selected:", doctor);
  };

  const handleCheckedChange = ({
    row,
    value,
  }: {
    row: any;
    value: boolean;
  }) => {
    setDoctors((prev: any) =>
      prev.map((doc: any) =>
        doc.id === row.id ? { ...doc, emergencyPrivileges: value } : doc,
      ),
    );
  };

  const handlePageChange = ({
    pageIndex,
    pageSize: newPageSize,
  }: {
    pageIndex: number;
    pageSize: number;
  }) => {
    setCurrentPage(pageIndex);
    setPageSize(newPageSize);
  };

  const handleAddNewDoctor = () => {
    dispatch(showModal({
      type: ModalType.COMPONENT,
      title: 'Add New Doctor',
      component: <AddNewDoctor />,
      onClose: () => {
        // Here you would typically refresh the doctors list from your API
        // For now, we'll just use the sample data
        setDoctors(sampleDoctorData);
      }
    }));
  };

  const doctorTableColumns: TableColumnsItem[] = [
    {
      key: "fullName",
      name: "Doctor Name",
      type: ColumnType.CUSTOM,
      width: "220px",
      cardTitle: true,
      customValue: (row: any) =>
        `${row.title || ""} ${row.firstName} ${row.lastName}`.trim(),
    },
    {
      key: "department",
      name: "Department",
      type: ColumnType.TEXT,
      width: "180px",
      cardOrder: 1,
    },
    {
      key: "specialization",
      name: "Specialization",
      type: ColumnType.TEXT,
      width: "200px",
      cardOrder: 2,
    },
    {
      key: "email",
      name: "Email",
      type: ColumnType.TEXT,
      width: "220px",
      cardOrder: 3,
    },
    {
      key: "phone",
      name: "Phone",
      type: ColumnType.TEXT,
      width: "140px",
      cardOrder: 4,
    },
    {
      key: "status",
      name: "Status",
      type: ColumnType.STATUS,
      width: "120px",
      cardOrder: 5,
    },
    {
      key: "actions",
      name: "Actions",
      type: ColumnType.BUTTON,
      width: "100px",
      cardOrder: 999,
      buttonsList: [
        {
          type: ButtonType.ICON,
          onPress: (e: React.MouseEvent, row: any) => {
            console.log("Edit doctor:", row);
            // Handle edit action
          },
          cssClass: "edit-button",
        },
        {
          type: ButtonType.ICON,
          onPress: (e: React.MouseEvent, row: any) => {
            console.log("Delete doctor:", row);
            // Handle delete action
          },
          cssClass: "delete-button",
        },
      ],
    },
  ];

  return (
    <div className="py-4">
      <MainTable
        data={doctors}
        columns={doctorTableColumns}
        onRowPress={handleRowPress}
        onCheckedChange={handleCheckedChange}
        showPagination={true}
        totalData={doctors.length}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChanged={handlePageChange}
        isLoading={false}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        showSearch={true}
        addButtonLabel="Add New Doctor"
        onAddNewItemPress={handleAddNewDoctor}
      />
    </div>
  );
};

export default DoctorsList;
